import React from "react";
import { useTranslation } from "react-i18next";
import { Popover } from "antd";

import { FavotiteBorderIcon, FavotiteIcon } from "./BusinessAddToFavoritesButton.styles";

export interface BusinessAddToFavoritesButtonProps {
  isFavorite: boolean;
  onClick: (isFavorite: boolean) => void;
}

const BusinessAddToFavoritesButton: React.FC<BusinessAddToFavoritesButtonProps> = ({ isFavorite, onClick }) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClick(!isFavorite);
  };

  const contentKey = isFavorite ? "business.actions.removeFromFavorites" : "business.actions.addToFavorites";
  const Icon = isFavorite ? FavotiteIcon : FavotiteBorderIcon;

  return (
    <Popover content={t(contentKey)} placement="top">
      <Icon onClick={handleClick} />
    </Popover>
  );
};

export default BusinessAddToFavoritesButton;
